import { createAction } from "redux-act";

export const setCash = createAction("SET_ATTACHMENT_TO_CASH");
export const setHashToPending = createAction("SET_HASH_TO_PENDING");
export const removeHashFromPending = createAction("REMOVE_HASH_FROM_PENDING");
export const setPromiseToStore = createAction("SET_PROMISE_TO_STORE");
export const setEditorActive = createAction("SET_EDITOR_ACTIVE");
